import React from 'react';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';
import styles from './Modal.module.css';

const ModalCloseBadge = ({ onClose, className }) => (
  <div
    onClick={onClose}
    style={{ width: '100%', position: 'relative' }}
    role="button"
    tabIndex={0}
    aria-label="Close"
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClose(e);
      }
    }}>
    <ReactSVG src={Icons.close} className={className || styles.closePx} />
  </div>
);

export default ModalCloseBadge;
